export default "__VITE_ASSET__cD3fDmP4__"